import API from "../shared/API/apiClient";

// export const getPrincipleDashboard = (legal_entity_id, reporting_year_id) => {
//   return API.get("/api/brsr-principles-dashboard", {
//     params: { legal_entity_id, reporting_year_id },
//   });
// };

export const getPrincipleDashboard = (legal_entity_id, reporting_year_id) => {
  return API.get("/api/principles/dashboard", {
    params: { legal_entity_id, reporting_year_id },
  });
};

export const getPrincipleDetail = async (
  principle_code,
  legal_entity_id,
  reporting_year_id
) => {
  try {
    const response = await API.get(`/api/principles/${principle_code}`, {
      params: {
        legal_entity_id,
        reporting_year_id,
      },
    });

    console.log("SERVICE API RESPONSE:", response.data);

    return response.data;
  } catch (error) {
    console.error("Principle Detail API Error:", error);
    throw error;
  }
};




// SAVE ALL RESPONSES
export const savePrincipleResponses = async (payload) => {
  return await API.post(
    "/api/principles/save-allresponses",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

// FINAL SUBMIT
export const submitPrincipleResponses = async (payload) => {
  return await API.post(
    "/api/principles/submit",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};
